<template>
  <section class="analyze-container">
    <header class="analyze-header">
      <h1 class="title">Let’s make your Profile even stronger!</h1>
      <p class="body">Thanks for everything you’ve shared so far - I’m getting a great picture of your work!</p>
      <p class="body" v-if="analyzeStore.missingFields.length">
        I didn’t see any
        <span v-if="analyzeStore.missingFields.length === 1">
          {{ analyzeStore.missingFields[0] }}
        </span>
        <span v-else>
          <span v-for="(field, idx) in analyzeStore.missingFields" :key="field">
            <template v-if="idx < analyzeStore.missingFields.length - 2">
              {{ field }},
            </template>
            <template v-else-if="idx === analyzeStore.missingFields.length - 2">
              {{ field }}
            </template>
            <template v-else>
              or {{ field }}
            </template>
          </span>
        </span>
        in what you’ve shared so far.
        <span v-if="analyzeStore.missingWorkHistory">Also, if you give me more info on your work history, that would be great.</span>
      </p>

      <p class="body">Please take a minute to add anything that might be missing. Add certifications, specialized tools, recent wins or projects you've led.</p>
    </header>
    <div class="analyze-content">
      <b-field>
        <b-input
        v-model="additionalDetails"
        type="textarea"
        placeholder="Add any missing details — certifications, recent wins, tools, or responsibilities you want to include…

The more you share, the smarter your Profile gets!"
        rows="10"
        ></b-input>
      </b-field>
      <p class="body">If you’re not sure, just skip this step. You can always update your Profile later.</p>
      <div class="button-group">
        <b-button
        type="is-primary"
        :disabled="!additionalDetails.trim()"
          :loading="loading"
          @click="submitAdditionalDetails"
          >
          Build My Profile!
        </b-button>
        <b-button
        type="is-secondary"
          :loading="loading"
          @click="skipDetails"
          >
          Skip
        </b-button>
      </div>
      <p v-if="error" class="error-msg">{{ error }}</p>
    </div>
    <p class="body bottom">Not sure? Skip it for now - you can always update your Profile later.</p>
    <OnboardingSteps :currentStep="2" />
  </section>
</template>

<script>
import { useAnalyzeStore } from '../stores/analyzeStore'
import OnboardingSteps from '@/components/OnboardingSteps.vue';

export default {
  name: 'AnalyzeDetails',
  components: {
    OnboardingSteps
  },
  created() {
    if (this.$cookies.isKey("teamwrkr-token")) {
      this.$router.push('/');
    }
    this.analyzeStore = useAnalyzeStore();
    if (this.$route.query.user) {
      this.fetchAndRehydrateUserData(this.$route.query.user).then(userData => {
        if (userData) {
          this.analyzeStore.setUser(userData);
        }
      });
    }
    console.log("ANALYZE STORE ON DETAILS PAGE:", this.analyzeStore.user);
  },
  data() {
    return {
      missingFields: [],
      additionalDetails: '',
      loading: false,
      error: ''
    };
  },
  methods: {
     async fetchAndRehydrateUserData(userId) {
      console.log('Fetching user data for ID:', userId);
      try {
        const response = await this.axios.get(
          `${process.env.VUE_APP_API_URL}/users/${userId}`
        );
        return response.data;
      } catch (err) {
        console.error('Error fetching user data:', err);
        return null;
      }
    },
    async submitAdditionalDetails() {
      this.analyzeStore.setResumeText(this.analyzeStore.resumeText + "\n\n" + this.additionalDetails);
      this.loading = true;
      this.error = '';
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/additional-details`,
          {
            resumeText: this.analyzeStore.resumeText,
            additionalDetails: this.additionalDetails,
            user: this.analyzeStore.user
          },
          { headers: { Authorization: `Onboarding ${this.analyzeStore.onboardingToken}` } }
        );
        console.log("STEP 2 ANALYSIS RESPONSE:", response.data);
        this.analyzeStore.setAnalysis(response.data);
        this.$router.push({ name: 'AnalyzeAspirations' });
      } catch (err) {
        this.error = err?.response?.data?.message || 'Could not submit details. Please try again.';
      } finally {
        this.loading = false;
      }
    },
    skipDetails() {
      this.$router.push({
        name: 'AnalyzeAspirations',
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.analyze-container {
  background: $color-surface-alt;
  border-radius: 1.2rem;
  box-shadow: 0 4px 32px rgba(170, 118, 214, 0.07);
  padding: 2.5rem 2rem 2rem 2rem;
  max-width: 700px;
  margin: 2.5rem auto;
  color: $color-text;
}

.analyze-header {
  margin-bottom: 2rem;
  text-align: center;

  .title {
    font-size: 2rem;
    font-weight: 700;
    color: $color-primary;
    margin-bottom: 1.7rem;
  }
  .subtitle {
    font-size: 1.15rem;
    color: $color-text-muted;
    margin-bottom: 0.7rem;
    font-style: italic;
  }
  .body {
    font-size: 1.05rem;
    color: $color-text;
    margin-bottom: 0.4rem;
    &.bottom{
      // margin-bottom: 1.5rem; TODO:
    }
  }
}

.analyze-content {
  background: $color-surface;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(170, 118, 214, 0.05);
  padding: 2rem 1.2rem 1.5rem 1.2rem;
  margin-bottom: 2rem;
}

.b-field {
  margin-bottom: 1.5rem;
}

.b-input textarea {
  background: $color-surface-alt;
  border: 1.5px solid $color-primary;
  border-radius: 0.7rem;
  color: $color-text;
  font-size: 1.08rem;
  padding: 1rem;
  transition: border-color 0.18s;
  &:focus {
    border-color: $color-accent;
    outline: none;
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.2rem;
}

.b-button {
  border-radius: 0.7rem;
  font-weight: 700;
  font-size: 1.08rem;
  border: none;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
  &.is-primary {
    background: $color-primary;
    color: $color-surface;
    transition: background 0.18s, color 0.18s;
    &:hover, &:focus {
      background: $color-accent;
      color: $color-surface;
    }
  }
  &.is-secondary {
    background: $color-surface-soft;
    color: $color-primary;
    &:hover, &:focus {
      background: $color-border;
      color: $color-text;
    }
  }
}

.error-msg {
  color: $color-accent;
  font-weight: 600;
  margin-top: 1rem;
}

@media screen and (max-width: 700px) {
  .analyze-container {
    padding: 1.2rem 0.5rem;
    max-width: 99vw;
  }
  .analyze-content {
    padding: 1rem 0.3rem;
  }
}
</style>
